<template>
    <h1 class="cusTitle">{{yyMsg}}</h1>
</template>

<script>
export default {
    props:['yyMsg']
}
</script>

<style lang="scss" scoped>
.cusTitle{
    position: relative;

    &:after{
        content:'';
        position: absolute;
        top: 0;
        left: 0;
    }
}
</style>